import { createVariantUrl } from "../createVariantUrl.js";
import { preferHeader } from "./networkUtils/preferHeader.js";
import { sherbertFetch } from "./networkUtils/sherbertFetch.js";
/**
 * Fetch a variant of an asset.
 * @param options - The options for fetching the variant.
 * @param options.variants - The variants to fetch.
 * @param options.assetId - The ID of the asset.
 * @param options.assetVersion - The version of the asset.
 * @param options.signature - The signature of the asset.
 * @param options.abortSignal - [optional] An abort signal to cancel the request.
 * @param options.method - [optional] The HTTP method to use. Defaults to "GET".
 * @param options.pageNum - [optional] The page number to fetch.
 * @param options.itemNumber - [optional] The item number for extracted logos.
 * @returns A promise that resolves to the response from the variant URL.
 * @example
 * ```ts
 * const response = await getVariant({ variants: [{ variant: "thumb" }], assetId: "123", signature: "456" });
 * ```
 */
export async function getVariant({ variants, assetId, assetVersion, signature, abortSignal, method = "GET", pageNum, itemNumber, }) {
    const variantUrl = createVariantUrl({
        variants,
        assetId,
        signature,
        version: assetVersion,
        pageNum,
        itemNumber,
    });
    const response = await sherbertFetch(() => [
        variantUrl,
        {
            method,
            signal: abortSignal,
            headers: preferHeader(),
        },
    ]);
    return { response, variantUrl };
}
